import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Header from "../components/header";
import { Rating } from "../components/rating";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import clientBannerImg from "../images/client.jpg";

function Clients() {
  const { data: reviews, isLoading } = useQuery(["reviews"], async () => {
    const response = await window.fetch(`${BASE_URL}/reviews`);
    return await response.json();
  });

  const navigate = useNavigate();

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={clientBannerImg}>
        <div className="my-5 py-5">
          <h1 className="fs-56 text-capitalize flex align-items-center text-center header-background-image-size">
            Our Clients
          </h1>
        </div>
      </Header>
      <div className="container-fluid pt-13 pb-9">
        <div className="ms-13 me-13">
          <div className="row">
            {reviews?.reviews?.map((reviewSide, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4 mb-5">
                <div
                  className="bg-white p-3 rounded-lg mb-5 review-shadow position-relative transform-up h-100 cursor-pointer"
                  onClick={() => navigate(`/clients/project/${reviewSide?.id}`)}
                >
                  <div className="d-flex justify-content-center">
                    <img
                      src={`${IMAGE_BASE_URL}/${reviewSide?.image}`}
                      alt="user"
                      className="img-fluid d-block mx-auto"
                    />
                  </div>
                  <div className="text-center mt-3">
                    <h3 className="fs-18 fw-bold text-secondary">
                      {reviewSide?.title}
                    </h3>

                    <div className="d-flex justify-content-center">
                      <Rating />
                    </div>
                    <p
                      className="fs-16 mt-3 mb-4 text-spanish-gray"
                      dangerouslySetInnerHTML={{
                        __html: reviewSide?.description,
                      }}
                    />
                  </div>
                  <div className="review-card-border"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Clients;
